import { Link } from 'react-router-dom';
import { CheckSquare, Clock3 } from 'lucide-react';
import { useNotifications } from '@api/hooks/useNotifications';
import { Card, CardContent, CardHeader, CardTitle } from '@components/common/Card';
import { LoadingSpinner } from '@components/common/LoadingSpinner';

export const ApprovalRemindersWidget = () => {
  const { data, isLoading } = useNotifications({
    category: 'approval_reminder',
    status: 'unread',
    limit: 5,
  });

  if (isLoading) {
    return (
      <Card>
        <CardContent>
          <LoadingSpinner />
        </CardContent>
      </Card>
    );
  }

  const notifications = data?.items ?? [];

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Clock3 className="h-5 w-5 text-primary-500" />
            <CardTitle>Approval Reminders</CardTitle>
          </div>
          <Link
            to="/notifications?category=approval_reminder"
            className="text-sm font-medium text-primary-500 hover:text-primary-600"
          >
            Open inbox
          </Link>
        </div>
      </CardHeader>
      <CardContent>
        {notifications.length === 0 ? (
          <div className="rounded-lg border border-dashed border-border-default p-6 text-sm text-content-secondary">
            No unread approval reminders.
          </div>
        ) : (
          <div className="space-y-3">
            {notifications.map((notification) => {
              const payload = notification.payload ?? {};
              const entityLabel = payload.document_type && payload.document_id
                ? `${payload.document_type} ${payload.document_id}`
                : payload.entity_type && payload.entity_id
                ? `${payload.entity_type} ${payload.entity_id}`
                : 'Pending approval item';

              return (
                <div key={notification.id} className="rounded-lg border border-border-default p-3">
                  <div className="flex items-start gap-3">
                    <CheckSquare className="mt-0.5 h-4 w-4 text-amber-500" />
                    <div>
                      <p className="font-medium text-content-primary">{entityLabel}</p>
                      <p className="mt-1 text-sm text-content-secondary">
                        Step {payload.step_number ?? '?'} reminder at hour {payload.reminder_hour ?? '?'}
                      </p>
                      {notification.body ? (
                        <p className="mt-1 text-xs text-content-muted">{notification.body}</p>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
